import { z } from "zod";

export const CustomizationFlagEnum = z.enum([
  "asfCourses",
  "bkfCourses",
  "autovioSupportCenter",
  "instructorSupportCenter",
  "carSharing",
  "paymentAndInvoicing",
  "reports",
  "studentAdministrativeOnboarding",
  "simulatorDrivingLessons",
  "zoomMeetings",
  "theoryLearning",
  "skipCreditCheckForInvites",
  "pickupService",
  "pickupFromHomeAddress",
  // TODO[APP-6518]: Remove this flag when the mobile-app release is fully adapted to the new flags.
  "cancellationPolicyPerLesson",
  "cancellationPolicyPerTheoryAppointment",
  "cancellationPolicyPerPracticalAppointment",
  "cancellationPolicyPerSimulatorAppointment",
  "newStudentsCanBookDrivingLessons",
  "newStudentsCanBookTheoryLessonsInAllBranches",
  "referralProgram",
  "canAddGiftedCredits",
  "canManageStripeIBAN",
  "studentsMustSignDocuments",
  "supportForTheEmploymentAgency",
  "dunning",
  "studentsCanEditOnboardingChecklist",
  "studentsCanBookTheoryLessons",
  "studentsMustAttendEveryTheoryLecture",
  "chargeExamAuthorityFees",
  "canCreateStudents",
  "subscriptionPackages",
  "autoCreateAusbildungsnachweis",
  "autoCreateSchaltnachweis",
  "trucks",
  "buses",
  "tractors",
  "nextGenerationInvoicing",
  "canUseExternalBankTransfer",
  "useUseStripeForB2BPayments",
]);
export type CustomizationFlag = z.infer<typeof CustomizationFlagEnum>;

export const ALL_CUSTOMIZATION_FLAGS = CustomizationFlagEnum.options;
